exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select_container[data-v-292edcc4]{width:100%}.custom-table-text[data-v-292edcc4]{font-size:14px;height:40px}@media screen and (max-width:768px){.custom-table-text[data-v-292edcc4]{font-size:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-292edcc4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shift/shift-personel.vue
// module id = 1115
// module chunks = 0